"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = retry;
async function retry(fn, retriesLeft = 3, interval = 1000, exponential = false) {
    try {
        return await fn();
    }
    catch (error) {
        if (retriesLeft) {
            await new Promise(r => setTimeout(r, interval));
            return retry(fn, retriesLeft - 1, exponential ? interval * 2 : interval, exponential);
        }
        else
            throw error;
    }
}
